import request from '@/utils/request'

// 获取会员权益列表
export function getMemberBenefitList(data) {
  return request({
    url: '/admin/operate/webMemberBenefit/list',
    method: 'post',
    data
  })
}

// 新增会员权益
export function addMemberBenefit(data) {
  return request({
    url: '/admin/operate/webMemberBenefit/add',
    method: 'post',
    data
  })
}

// 编辑会员权益
export function updateMemberBenefit(data) {
  return request({
    url: '/admin/operate/webMemberBenefit/edit',
    method: 'post',
    data
  })
}

// 删除会员权益
export function removeMemberBenefit(data) {
  return request({
    url: '/admin/operate/webMemberBenefit/remove',
    method: 'post',
    data
  })
}
